export default __webpack_public_path__ + "static/media/playstore.f631df44.svg";